// extracted by mini-css-extract-plugin
module.exports = {"root":"CategorySlider_root__3cMsT"};